import platform from '@propertypal/shared/src/utils/platform';
import { useSearchParams } from 'next/navigation';
import React from 'react';
import useSearchQuery, { SEARCH_QUERY_PARAM } from '../hooks/useSearchQuery';
import FaqBreadcrumbs from './FaqBreadcrumbs';
import FaqContactUs from './FaqContactUs';
import {
  FaqContentWrapper,
  FaqMainContent,
  FaqMainContentContainer,
  FaqMainContentWrapper,
  FaqSearchTitle,
} from './FaqContentContainer.style';
import { FaqPageContainerProps } from './FaqPageContainer';
import FaqRelatedArticles from './FaqRelatedArticles';
import FaqSearch from './FaqSearch';
import FaqSearchResults from './FaqSearchResults';

interface FaqContentContainerProps extends FaqPageContainerProps {}

const FaqContentContainer: React.FC<FaqContentContainerProps> = ({
  children,
  hideContact,
  breadcrumbs,
  base,
  relatedArticles,
  agent,
}) => {
  const searchParams = useSearchParams();

  // check whether there is a faq search query
  const searchQuery = searchParams.get(SEARCH_QUERY_PARAM);

  const { searchText, setSearchText } = useSearchQuery();

  const onClearQuery = () => {
    setSearchText('');
  };

  return (
    <FaqContentWrapper>
      <FaqSearchTitle>
        {platform.select('Find the answers to all things PropertyPal here', 'Frequently Asked Questions')}
      </FaqSearchTitle>
      <FaqSearch searchText={searchText} setSearchText={setSearchText} />
      {/* if search query active, render search markup */}
      {searchQuery ? (
        <FaqSearchResults searchQuery={searchQuery} onClearQuery={onClearQuery} agent={agent} />
      ) : (
        <FaqMainContent data-testid="faq-main-content" base={base} id="faq-container">
          <FaqMainContentContainer>
            <FaqMainContentWrapper>
              {breadcrumbs && <FaqBreadcrumbs breadcrumbs={breadcrumbs} onClearQuery={onClearQuery} />}
              {children}
            </FaqMainContentWrapper>
            {relatedArticles && relatedArticles.length > 0 && (
              <FaqRelatedArticles relatedArticles={relatedArticles} agent={agent} onClearQuery={onClearQuery} />
            )}
          </FaqMainContentContainer>
        </FaqMainContent>
      )}
      {!hideContact && <FaqContactUs agent={agent} />}
    </FaqContentWrapper>
  );
};

export default FaqContentContainer;
